import { ref } from "vue";

/** FORGE-645 — Bump after globalConfig is available (vue-app-mounted). */
const orderPageContextVersion = ref(0);

export function getOrderPageContextVersion() {
  return orderPageContextVersion;
}

/** True when the current page is an order page (globalConfig.isOrderPage). */
export function isOrderPageContext() {
  return window.globalConfig?.isOrderPage === true;
}

/** Call once the async page template has assigned window.globalConfig. */
export function notifyOrderPageContextReady() {
  markOrderPageContainer();
  orderPageContextVersion.value += 1;
}

/** FORGE-645 — Scope order-page CSS to pages with globalConfig.isOrderPage. */
export function markOrderPageContainer() {
  if (!isOrderPageContext()) {
    return;
  }

  document.querySelector(".container")?.classList.add("vg-orderpage");
}
